import React, { useState } from "react";
import { api, hasRole } from "@/lib/api";
import { Btn } from "@/components/erp/ui";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

// Konfirmasi invoice DRAFT -> APPROVED + Work Order (Finance / admin utama, butuh minimal 1 termin dibayar)
export const ConfirmInvoice = ({ inv, me, onDone }) => {
  const [busy, setBusy] = useState(false);
  const allowed = me?.role === "owner" || me?.role === "admin" || hasRole(me, "finance");
  const paid = (inv.termins || []).some((t) => t.paid);
  const go = async () => {
    if (!window.confirm(inv.wo_code ? `Konfirmasi invoice ${inv.code}? Invoice akan terhubung ke ${inv.wo_code}.` : `Konfirmasi invoice ${inv.code}? Work Order akan langsung dibuat.`)) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/invoices/${inv.id}/confirm`);
      toast.success(data.created ? `Invoice APPROVED \u2014 Work Order ${data.wo_code} dibuat` : `Invoice APPROVED \u2014 terhubung ke ${data.wo_code}`);
      onDone(data.invoice);
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal konfirmasi"); }
    setBusy(false);
  };
  return (
    <div className="border border-amber-200 bg-amber-50/60 rounded-xl p-3 text-sm" data-testid="invoice-confirm-box">
      <div className="font-medium">Invoice masih DRAFT</div>
      <p className="text-xs text-slate-600 mt-0.5">
        {!paid ? "Tandai pembayaran (lunas atau minimal 1 termin) dulu, baru bisa dikonfirmasi." : inv.wo_code ? `Setelah dikonfirmasi invoice terhubung ke ${inv.wo_code}.` : "Setelah dikonfirmasi Work Order langsung terbentuk."}
        {!allowed && " Konfirmasi hanya oleh Finance atau admin utama."}
      </p>
      {allowed && <Btn className="mt-2" data-testid="invoice-confirm-btn" disabled={!paid || busy} onClick={go}><CheckCircle2 className="w-4 h-4" /> {busy ? "Memproses\u2026" : "Konfirmasi Invoice"}</Btn>}
    </div>
  );
};
